module.exports = __webpack_public_path__ + "static/adjustable-base-2-massage-6ad12bbd2a9f2fb3dc9668c84dc6d77a.png";